import React from 'react';
import { useSelector } from 'react-redux';

import { ReduxState } from '../../AppLoader/types';
import TopNavigationBar from './TopNavigationBar';

export default function TopNavigationWrapper(): JSX.Element | null {
  const topNavConfig = useSelector(
    (state: ReduxState) => state.ui.topNavConfig
  );

  if (!topNavConfig) return <></>;

  return (
    <TopNavigationBar
      desktop={topNavConfig.desktop}
      tablet={topNavConfig.tablet}
      mobile={topNavConfig.mobile}
      logoUrl={topNavConfig.logoUrl}
      showSearch={topNavConfig.showSearchByDefault ?? true}
    />
  );
}
